import { z } from 'zod';
import type { WarehouseStatsDto } from './inventory';
import { billingRulesSchema } from './settings';
import { idSchema, isoDate, isoDateTime, paginationSchema } from './common';

export interface DashboardDto {
  stats: WarehouseStatsDto;
  entriesToday: number;
  exitsToday: number;
  openOutboundOrders: number;
  draftInvoices: number;
  /** false mientras la regla de días facturables esté pendiente de confirmar. */
  billingRulesConfirmed: boolean;
}

export const listAuditQuerySchema = paginationSchema.extend({
  action: z.string().trim().max(60).optional(),
  userId: idSchema.optional(),
  entityType: z.string().trim().max(40).optional(),
  entityId: z.string().trim().max(40).optional(),
  from: isoDate.optional(),
  to: isoDate.optional(),
});
export interface ListAuditQuery {
  page?: number;
  pageSize?: number;
  action?: string;
  userId?: number;
  entityType?: string;
  entityId?: string;
  from?: string;
  to?: string;
}

/** Simulación de la regla de días (pantalla de configuración). */
export const simulateBillingDaysSchema = z.object({
  rules: billingRulesSchema,
  enteredAt: isoDateTime,
  exitedAt: isoDateTime,
});
export type SimulateBillingDaysInput = z.input<typeof simulateBillingDaysSchema>;

export interface SimulateBillingDaysResult {
  days: number;
  firstDay: string | null;
  lastDay: string | null;
}
